import '../styles/navbar.css';
import Button from './Button';
import { Link } from 'react-router-dom';

interface props {
  scrollPos: number;
  callback: (loc: string) => void;
}

export default function Navbar({ scrollPos, callback }: props) {
  return (
    <nav className={`navigation ${scrollPos < 10}`}>
      <div className="navigation-inner">
        <Link to="/" style={{display: 'flex'}}>
          <img className="navigation-logo" src={require('../assets/Logo.png')} alt="Logo" />
        </Link>
        <div className="navigation-menu">
          {/* About section link (uses callback to scroll) */}
          <Link to="/" className="navigation-link">
            About
          </Link>

          {/* Link to Events page */}
          <Link to="/events" className="navigation-link">
            Events
          </Link>

          {/* Button to scroll to the Join Us section */}
          <Button type="secondary" text="Join" callback={() => callback('join')} />
        </div>
      </div>
    </nav>
  );
}
